import { __assign } from "tslib";
import * as React from 'react';
import { BaseTableHeadCell } from './base-table-head-cell';
import { getLegacyBaseDriverFromWrapper } from '../../../../common/base-driver';
import { renderAndMountComponent } from '@wix/answers-lib';
export var createLegacyBaseTableHeadCellDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.table-head-cell', BaseTableHeadCell.name);
    return {
        click: function () { return baseDriver.click(); },
        getClassNames: function () { return baseDriver.elem.className.split(' '); }
    };
};
export var createBaseTableHeadCell = function (props) {
    var element = renderAndMountComponent(React.createElement(BaseTableHeadCell, __assign({}, props)));
    return createLegacyBaseTableHeadCellDriver(element);
};
//# sourceMappingURL=base-table-head-cell.legacy-driver.js.map